<template>
    <div class="media messages-container media-clearfix-xs-min media-grid" :style="elmsOffsetTop">
        <div v-if="student" class="media-body js_panel_messages">
            <ChatTeacherComponent
                    v-if="student"
                    @sendMessage="onClickSendMessage"
                    :teacher="teacher"
                    :student="student"
                    :messages="messages"
            >
            </ChatTeacherComponent>

            <div v-if="next_page_url" class="elms elms_center">
                <button class="btn btn-primary" v-if="next_page_url" @click="load_next">{{ $t('show_more') }}</button>
            </div>
        </div>
        <div class="media-right">
            <div class="messages-list">
                <div class="panel panel-default " data-z="0.5">
                    <div class="is_groups form-group">

                        <div class="aselect"
                             :data-value="value"
                             :data-list="groups">
                            <div class="selector" @click="toggle()" style="height: auto;">
                                <div class="selector__label">
                                    <span>{{ value }}</span>
                                    <div class="arrow" :class="{ expanded : visible }">
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div :class="{ hidden : !visible, visible }">
                                    <ul>
                                        <li :class="{ current : item.name === value }"
                                            class="z-messages-num" v-for="item in groups"
                                            v-if="item.unread_messages > 0"
                                            @click="group = item.id; select(item.name); onChangeGroup()">
                                            {{ item.name }}
                                            <span class="z-messages-num__txt">
                                                {{ item.unread_messages }}
                                            </span>
                                        </li>
                                        <li :class="{ current : item.name === value }"
                                            v-for="item in groups"
                                            v-if="parseInt(item.unread_messages) === 0"
                                            @click="group = item.id; select(item.name); onChangeGroup()">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                    <ul class="list-group is_group" :class="{is_active : students.length > 0 && oldChat === false}">
                        <li v-for="(student, index) in students" class="list-group-item"
                            :class="{active : isActive === index}">
                            <a @click="onChangeUser(student, index)">

                                <div class="media v-middle z-media-cart z-media-cart_small" style="--size:50px">
                                    <div class="z-media-cart__thumb" style="border-radius: 0;">

                                        <img v-if="student.banner" :src="student.banner" alt="user"
                                             class="z-media-cart__thumb--img">
                                        <div v-else class="z-media-cart__thumb--icn">{{ student.initials }}</div>

                                    </div>
                                    <div class="media-body z-media-cart__body" style="line-height: 1.35;"
                                         :class="{is_num: student.unread_student_messages > 0}">
                                        <span class="date" v-if="student.last_message">
                                            {{ student.last_message.date_create }}
                                        </span>
                                        <span class="user">{{ student.first_name }} {{ student.last_name }}</span>
                                        <span class="messages-num" v-if="student.unread_student_messages > 0">
                                            {{ student.unread_student_messages }}
                                        </span>
                                        <div class="text-light" v-if="student.last_message">
                                            <span v-html=" scrollMessage(student.last_message.messages) "></span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="list-group-item" v-if="students" :class="{active : isActive === 'system'}">
                            <a @click="selectSystemChat(students[0])">

                                <div class="media v-middle z-media-cart z-media-cart_small" style="--size:50px">
                                    <div class="z-media-cart__thumb" style="border-radius: 0;">
                                        <div class="z-media-cart__thumb--icn">ЗЧ</div>
                                    </div>
                                    <div class="media-body z-media-cart__body" style="line-height: 1.35;">
                                        <span class="user">Загальний чат</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>

                    <div class="old-chat">
                        <button type="button" class="old-chat__btn" @click="toggleOldChat()" >
                             <span style="min-width: 16px;
                                            height: 16px;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            background-color: seagreen;
                                            color: white;
                                            font-size: 10px;
                                            border-radius: 10px;
                                            transition: 300ms;
                                            padding-left: 3px;
                                            padding-right: 3px;"
                                 class="messages-num" v-if="past_students && past_students.length > 0 && total_count_past_chat > 0">
                                 {{ total_count_past_chat }}
                            </span>
                            <template v-if="oldChat">
                                <span>Приховати</span>
                                <i class="fa fa-times" style="font-size: 10px; margin-right: 1px;"></i>
                            </template>
                            <template v-else>
                                <span>Попередні чати</span>
                                <div class="arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></div>
                            </template>
                        </button>
                        <ul class="list-group old-chat__body" :class="{ is_active : oldChat }">
                            <li v-for="(student, index) in past_students" class="list-group-item"
                                :class="{active : isActive === index}">
                                <a @click="onChangeUser(student, index)">

                                    <div class="media v-middle z-media-cart z-media-cart_small" style="--size:50px">
                                        <div class="z-media-cart__thumb" style="border-radius: 0;">

                                            <img v-if="student.banner" :src="student.banner" alt="user"
                                                 class="z-media-cart__thumb--img">
                                            <div v-else class="z-media-cart__thumb--icn">{{ student.initials }}</div>

                                        </div>
                                        <div class="media-body z-media-cart__body" style="line-height: 1.35;"
                                             :class="{is_num: student.unread_student_messages > 0}">
                                            <span class="date" v-if="student.last_message">
                                                {{ student.last_message.date_create }}
                                            </span>
                                            <span class="user">{{ student.first_name }} {{ student.last_name }}</span>
                                            <span class="messages-num" v-if="student.unread_student_messages > 0">
                                                {{ student.unread_student_messages }}
                                            </span>
                                            <div class="text-light" v-if="student.last_message">
                                                <span v-html="scrollMessage(student.last_message.messages)"></span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </li>

                            <li class="list-group-item" v-if="students" :class="{active : isActive === 'system'}">
                                <a @click="selectSystemChat(students[0])">

                                    <div class="media v-middle z-media-cart z-media-cart_small" style="--size:50px">
                                        <div class="z-media-cart__thumb" style="border-radius: 0;">
                                            <div class="z-media-cart__thumb--icn">ЗЧ</div>
                                        </div>
                                        <div class="media-body z-media-cart__body" style="line-height: 1.35;">
                                            <span class="user">Загальний чат</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>


import ChatTeacherComponent from "./ChatTeacherComponent";


export default {
    name: "TeacherChatWrapperComponent",
    props: ['teacher_data', 'groups', 'past_students','total_count_past_chat']
    ,
    components: {
        ChatTeacherComponent
    },
    data() {
        return {
            messages: [],
            students: '',
            count_past_chat: 0,
            student: null,
            group: this.$t('Group'),
            channel: '',
            isActive: false,
            next_page_url: '',
            prev_page_url: '',
            value: this.$t('groups_list'),
            visible: false,
            elmsoffsettop: '--elmsOffsetTop:0px',
            oldChat: false
        }
    },

    computed: {
        elmsOffsetTop: function () {
            return this.elmsoffsettop;
        },
        teacher: function () {
            return JSON.parse(this.teacher_data)
        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible;
        },
        toggleOldChat() {
            this.oldChat = !this.oldChat;
        },
        select(option) {
            this.value = option;
        },
        load_next() {


            if (this.isActive === 'system') {
                var data_request = {
                    'group_id': this.group,
                    'teacher_id': this.teacher.id
                };

                window.Echo.leave(this.channel);
                window.Echo.channel('system.' + this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({data}) => {
                    this.messages.unshift(data.message);
                    console.log(data.message);

                });
                this.channel = 'system.' + this.teacher.email + '.' + this.student.email;

            } else {
                var data_request = {
                    'teacher_email': this.teacher.email,
                    'student_email': this.student.email,
                };

                window.Echo.leave(this.channel);
                window.Echo.channel(this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({data}) => {
                    this.messages = [...this.messages, data.message];
                    this.messages.unshift(data.message);
                })
                this.channel = this.teacher.email + '.' + this.student.email;
            }
            axios({
                url: this.next_page_url,
                method: 'post',
                data: data_request
            })
                    .then((response) => {
                        console.log(response);
                        this.$root.storage.global_count = response.data.new_count;
                        for (let i = 0; i < response.data.messages.data.length; i++) {
                            this.messages = [...this.messages, response.data.messages.data[i]];
                        }
                        this.next_page_url = response.data.messages.next_page_url;
                    })
                    .catch((error) => {
                        reject(error)
                    });

        },

        onChangeUser(student, index) {
            this.isActive = index;
            this.student = student
            axios({
                url: '/chat/getChatHistory',
                method: 'post',
                data: {
                    'teacher_email': this.teacher.email,
                    'student_email': this.student.email,
                }
            })
                    .then((response) => {
                        this.$root.storage.global_count = response.data.new_count;
                        this.count_past_chat = response.data.new_count;
                        this.messages = response.data.messages.data;
                        this.next_page_url = response.data.messages.next_page_url;
                    })
                    .catch((error) => {
                        reject(error)
                    });
            window.Echo.leave(this.channel);
            window.Echo.channel(this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({data}) => {
                // this.messages = [...this.messages, data.message];
                this.messages.unshift(data.message);
            })
            this.channel = this.teacher.email + '.' + this.student.email;

        },
        selectSystemChat(student) {
            this.student = student
            this.isActive = 'system';
            axios({
                url: '/chat/getChatTeacherSystemHistory',
                method: 'post',
                data: {
                    'group_id': this.group,
                    'teacher_id': this.teacher.id
                }
            })
                    .then((response) => {
                        this.$root.storage.global_count = response.data.new_count;
                        this.messages = response.data.messages.data;
                        this.next_page_url = response.data.messages.next_page_url;
                    })
                    .catch((error) => {
                        reject(error)
                    });
            window.Echo.leave(this.channel);
            window.Echo.channel('system.' + this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({data}) => {
                this.messages.unshift(data.message);
                console.log(data.message);

            });
            this.channel = 'system.' + this.teacher.email + '.' + this.student.email;
            console.log(this.messages);
        },
        onChangeGroup() {
            this.oldChat = false;
            return new Promise((resolve, reject) => {
                axios({
                    url: '/chat/getStudents',
                    method: 'post',
                    data: {
                        'group_id': this.group,
                        'teacher': this.teacher.email,
                        'teacher_id': this.teacher.id
                    }
                })
                        .then((response) => {
                            this.students = response.data
                        })
                        .catch((error) => {
                            reject(error)
                        })
            })
        },
        onClickSendMessage(data) {
            if (this.isActive === 'system') {
                var url = '/chat/system';
                var data_request = {
                    'message': this.teacher.first_name + ': ' + data.message,
                    'user': this.teacher,
                    'teacher': 'system',
                    'student': 'system',
                    'group_id': this.group,
                }
            } else {
                var url = '/chat';

                var data_request = {
                    'message': this.teacher.first_name + ': ' + data.message,
                    'user': this.teacher,
                    'student': this.student.email,
                }
            }

            return new Promise((resolve, reject) => {
                axios({
                    url: url,
                    method: 'POST',
                    data: data_request
                })
                        .then((response) => {
                            console.log(response);
                        })
                        .catch((error) => {
                            reject(error)
                        })
            })
        },
        scrollMessage(mes) {
            var arr = mes.split(':');
            arr.shift();
            var str = arr.join(':');
            return str;
        },
    },
    mounted() {
        this.elmsoffsettop = `--elmsOffsetTop: ${this.$el.getBoundingClientRect().top + document.body.scrollTop}px`;
        this.count_past_chat = this.total_count_past_chat;
    }
}
</script>

